import { render, staticRenderFns } from "./step-contacts-header.vue?vue&type=template&id=46a1a7de"
import script from "./step-contacts-header.vue?vue&type=script&lang=ts"
export * from "./step-contacts-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports